
export interface Opportunities {
  opportunityId: number
  sectorId: number
  sector: string,
  opportunityName: string
  statusId: number
  customerId: number
  cuurentUserID: number
  closingDate: string
  userId: string
  customerName: string
  sbmchannel: string
  techLeadName: string
  renewable: boolean
  sourceId: number
  attachCount: number
  sssOwnerName: string
  customerGroupName: string
  creationDate: string
  order: [
    {
      productKind: string
      orderId: number
      orderPrice: string
      categoryId: number
    }
  ]
}

export interface OpportunityHistory {
  opportunityId: number;
  action: any;
  actionDate: Date;
  user: number;
  userName: string;
  details: string;
}

export class OpportunityDataRow {
  year = '';
  status = '';
  statusClass = '';
  statusId = 0;
  quarter = '';
  month = '';
  type = '';
  sector = '';
  sectorId = 0;
  sectorClass = '';
  customer = '';
  customerId: number;
  opportunityName = '';
  opportunityId: number;
  techLeadName = '';
  customerGroupName = '';
  sss = 0;
  swg = 0;
  stg = 0;
  service = 0;
  sbmChannel = '';
  renewable: boolean;
  sourceId: number;
  productKind: String[];
  attachCount = 0;
  sssOwnerName = '';
  creationDate :Date;
  constructor() {
    this.productKind = new Array();
  }
}
